/**
 * KpiCard + KpiCardSkeleton – interne Bausteine für ProductKpiCards
 */
import type { ReactNode } from 'react'
import { Card, CardContent } from '@/components/v2/ui'

// ============================================================================
// KpiCard
// ============================================================================

export interface KpiCardProps {
  label: string
  value: ReactNode
  action?: ReactNode
  sub?: ReactNode
}

export function KpiCard({ label, value, action, sub }: KpiCardProps) {
  return (
    <Card>
      <CardContent className="pt-6">
        <p className="text-sm text-neutral-500 dark:text-neutral-400">{label}</p>
        <p className="mt-1 text-3xl font-bold text-neutral-900 dark:text-neutral-50">{value}</p>
        {sub && <div className="mt-1 text-sm">{sub}</div>}
        {action && <div className="mt-3">{action}</div>}
      </CardContent>
    </Card>
  )
}

// ============================================================================
// KpiCardSkeleton
// ============================================================================

export function KpiCardSkeleton() {
  return (
    <Card>
      <CardContent className="pt-6">
        <div className="h-4 w-24 rounded bg-neutral-200 dark:bg-neutral-700 animate-pulse" aria-hidden="true" />
        <div className="mt-2 h-9 w-16 rounded bg-neutral-200 dark:bg-neutral-700 animate-pulse" aria-hidden="true" />
      </CardContent>
    </Card>
  )
}
